import React from 'react';
import styles from './index.module.scss';

const FAQ_ITEMS = [
  {
    question: 'Do I have to block apps?',
    answer:
      'No. App locking is optional. Rat Race also works as a cute daily step tracker.',
  },
  {
    question: 'Do I need a fitness tracker?',
    answer: 'No. Rat Race pulls your step count straight from Apple Health.',
  },
  {
    question: 'Can I customize my rat?',
    answer: 'Absolutely. Spend your Cheddar on outfits, accessories, and more.',
  },
  {
    question: 'Why a rat?',
    answer:
      "Because building habits doesn't have to be serious. Your rat celebrates your wins and makes it fun.",
  },
];

export default function RatRaceFAQ() {
  return (
    <section className={styles.coreFeaturesSection}>
      <div className={styles.coreFeaturesInner}>
        <div className={styles.coreFeaturesHeadingWrap}>
          <h2 className={styles.coreFeaturesHeading}>FAQ</h2>
        </div>

        <div className={styles.coreFeaturesFaqGrid}>
          {FAQ_ITEMS.map((item) => (
            <div key={item.question} className={styles.coreFeaturesFaqCard}>
              <h3 className={styles.coreFeaturesFaqQuestion}>
                {item.question}
              </h3>
              <p className={styles.coreFeaturesFaqAnswer}>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
